export default __webpack_public_path__ + "static/media/4821123.8d4c6ae5.jpeg";